/**
 * Single Product - Course JS
 */

// CSS
import styles from '../scss/single-product-course.scss';

const $ = window.jQuery,
  bundleDetails = $('.product-main')
    .find('.product-details')
    .children('.product_cat-courses');

$('html').on('click', '[data-toggle-full-description]', (event) => {
  event.preventDefault();
  $('.product-short-description').toggleClass('is-hidden');
  $('.product-full-description').toggleClass('is-hidden');
});

$('html').on('click', '.product-add-to-cart', (event) => {
  $(event.currentTarget).addClass('is-loading');
});

$('html').on('change', 'input[name="member_discount_toggle"]', (event) => {
  if ($(event.currentTarget).is(':checked')) {
    $('.product-price-container').addClass('member-discount-price-visible');

    $('#modal-product-member-discount').modal('show');
  } else {
    $('.product-price-container').removeClass('member-discount-price-visible');
  }
});

$('#modal-product-member-discount').on('hidden.bs.modal', (event) => {
  $('input[name="member_discount_toggle"]').prop('checked', false);
  $('.product-price-container').removeClass('member-discount-price-visible');
});

if (bundleDetails.length > 0) {
  const bundleDetailsHeader = $('.product-main')
    .find('.product-details')
    .children('h2')
    .first();

  bundleDetails.find('h1').remove();
  bundleDetails
    .find('.woocommerce-product-details__short-description')
    .remove();
  bundleDetails.find('.bundled_product_images.images').remove();
  bundleDetails.find('.woocommerce').remove();
  bundleDetails.find('.bundle_error').remove();

  $(
    bundleDetails
      .find('.bundled_product.bundled_product_summary.product')
      .get()
      .reverse()
  ).each(function () {
    bundleDetailsHeader.after(
      $(this).find('.bundled_product_excerpt.product_excerpt')
    );
    bundleDetailsHeader.after($(this).find('.bundled_item_cart_details'));
    bundleDetailsHeader.after(
      $(this).find('.bundled_product_title.product_title')
    );
  });

  bundleDetails.remove();
}
